import React, { useState } from 'react'
import { FormBuilder } from 'components/FormBuilder'
import { userContext } from 'global/context/sub-contexts/userContext'
import { useForm } from 'react-hook-form'
import Button from '@mui/material/Button'
import { useYupValidationResolver } from 'hooks/useYupValidationResolver'
import { signInFormSchema } from './schema'
import analytics from 'global/AnalyticsData'
import { useFingerPrint } from 'hooks/useFingerPrint'
import { login } from 'services/auth'
import localStorageWrapper from 'util/LocalStorageWrapper'
import { getToken } from 'services/user'
import { CircularProgress } from '@mui/material'
import * as styles from './SignInForm.module.scss'

export const SignInForm = ({
  logoImageUrl = '/img/logo-blue.svg',
  onLoginSuccess,
}) => {
  const [isInProgress, setIsInProgress] = useState(false)
  const fingerPrintResults = useFingerPrint()
  const user_context = React.useContext(userContext)
  const [loginError, setLoginError] = useState()

  const onSubmit = async data => {
    handleLogin(data.email, data.password, false)
  }

  const resolver = useYupValidationResolver(signInFormSchema)
  const form = useForm({
    mode: 'onChange',
    defaultValues: {
      email: '',
      password: '',
    },
    resolver,
  })

  const { handleSubmit, register } = form

  const handleLogin = (username, password, seekEmail) => {
    setIsInProgress(true)
    const visitorId = fingerPrintResults?.visitorId || null
    login(username, password, visitorId, seekEmail)
      .then(result => {
        if (result.success === true) {
          user_context.setProfile(result.profile)
          user_context.setPoints(result.profile.points)

          analytics.setUser(result.profile)
          analytics.userEvent('login', result.profile)

          getToken()
            .then(data => {
              if (data.status === 200) {
                localStorageWrapper.setItem(
                  'accessToken',
                  data.detail.accessToken,
                )
              }
              onLoginSuccess()
            })
            .catch(e => {
              // not getting a legacy token isn't great, but we don't need to fail
              console.log(`getToken`, e)
            })
        } else {
          let errorMsg = 'Failed to login to account.' || result.message
          if (result.message) {
            errorMsg = result.message
          }
          setLoginError(errorMsg)
        }
      })
      .finally(() => {
        setIsInProgress(false)
      })
  }

  return (
    <FormBuilder
      form={form}
      formHeader={
        <img
          style={{
            marginBottom: 24,
          }}
          src={logoImageUrl}
          alt="logo"
        />
      }
      onSubmit={handleSubmit(onSubmit)}
      register={register}
      fields={[
        {
          name: 'email',
          label: 'Email',
          type: 'text',
          required: true,
        },
        {
          name: 'password',
          label: 'Password',
          type: 'password',
          inputType: 'password',
          required: true,
        },
      ]}
    >
      <Button
        className={styles.button}
        disabled={!form.formState.isValid || isInProgress}
        variant="contained"
        type="submit"
      >
        {isInProgress ? <CircularProgress color="white" size={18} /> : 'Log In'}
      </Button>
      <span className={styles.error}>{loginError}</span>
    </FormBuilder>
  )
}
